export default __webpack_public_path__ + "8cfc02b9e2d01a0de024dd4a0af350dc.jpg";